export const BOARD = 'BOARD';
export const BOARD_SUCCESS = 'BOARD_SUCCESS';
export const BOARD_ERROR = 'BOARD_ERROR';

export const BOARD_FILTER = 'BOARD_FILTER';
export const BOARD_FILTER_SUCCESS = 'BOARD_FILTER_SUCCESS';
export const BOARD_FILTER_ERROR = 'BOARD_FILTER_ERROR';

export const BOARD_DETAILS = 'BOARD_DETAILS';
export const BOARD_DETAILS_SUCCESS = 'BOARD_DETAILS_SUCCESS';
export const BOARD_DETAILS_ERROR = 'BOARD_DETAILS_ERROR';

export const ADD_BOARD = 'ADD_BOARD';
export const ADD_BOARD_SUCCESS = 'ADD_BOARD_SUCCESS';
export const ADD_BOARD_ERROR = 'ADD_BOARD_ERROR';

export const UPDATE_BOARD = 'UPDATE_BOARD';
export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS';
export const UPDATE_BOARD_ERROR = 'UPDATE_BOARD_ERROR';

export const DELETE_BOARD = 'DELETE_BOARD';
export const DELETE_BOARD_SUCCESS= 'DELETE_BOARD_SUCCESS';
export const DELETE_BOARD_ERROR ='DELETE_BOARD_ERROR';

export const CLEAR_ACTIVE_BOARD = 'CLEAR_ACTIVE_BOARD';

export const UPDATE_PINS_ORDER = 'UPDATE_PINS_ORDER'
export const UPDATE_PINS_ORDER_SUCCESS = 'UPDATE_PINS_ORDER_SUCCESS'
export const UPDATE_PINS_ORDER_ERROR = 'UPDATE_PINS_ORDER_ERROR'

export const UPDATE_INDIRECT_CHILDREN = 'UPDATE_INDIRECT_CHILDREN';
export const UPDATE_INDIRECT_CHILDREN_SUCCESS = 'UPDATE_INDIRECT_CHILDREN_SUCCESS';
export const UPDATE_INDIRECT_CHILDREN_ERROR = 'UPDATE_INDIRECT_CHILDREN_ERROR';
